import { render, staticRenderFns } from "./OutlinedLabel.vue?vue&type=template&id=17770586&scoped=true&lang=pug"
import script from "./OutlinedLabel.vue?vue&type=script&lang=js"
export * from "./OutlinedLabel.vue?vue&type=script&lang=js"
import style0 from "./OutlinedLabel.vue?vue&type=style&index=0&id=17770586&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17770586",
  null
  
)

export default component.exports